/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_EsppEligibilitySearchRowDto } from '../models/PagedResultDto_EsppEligibilitySearchRowDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppEligibilityService {

    /**
     * @param offeringPeriodId 
     * @param purchasePeriodId 
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardOfferingPeriodPurchasePeriodEligibilityImport(
offeringPeriodId: string,
purchasePeriodId: string,
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/eligibility/import',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId 
     * @param purchasePeriodId 
     * @param eligibilityStatus 
     * @param esppParticipantId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_EsppEligibilitySearchRowDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriodEligibility(
offeringPeriodId: string,
purchasePeriodId: string,
eligibilityStatus?: Array<string>,
esppParticipantId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_EsppEligibilitySearchRowDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/eligibility',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            query: {
                'EligibilityStatus': eligibilityStatus,
                'EsppParticipantId': esppParticipantId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId 
     * @param purchasePeriodId 
     * @param eligibilityStatus 
     * @param esppParticipantId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriodEligibilityExport(
offeringPeriodId: string,
purchasePeriodId: string,
eligibilityStatus?: Array<string>,
esppParticipantId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/eligibility/export',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            query: {
                'EligibilityStatus': eligibilityStatus,
                'EsppParticipantId': esppParticipantId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodImportSamplesEligibility(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/import-samples/eligibility',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
